import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { deliveriesAPI, type DeliveryFilters } from '../api/deliveries'

export const useDeliveries = (filters: DeliveryFilters = {}) => {
  return useQuery({
    queryKey: ['deliveries', filters],
    queryFn: () => deliveriesAPI.getAll(filters),
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  })
}
